// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.language-selection-wrapper {
  top: 50%;
  left: 50%;
}

.title {
  font-size: 21px;
  font-weight: 900;
}

.language-selection-image {
  width: 100%;
  max-width: 100%;
  min-width: 100%;
  border-radius: 0px 0px 30px 30px;
  margin-top: -2em;
}

@media (min-width: 1024px) and (max-width: 1640px) {
  .language-selection-image {
    width: 65%;
    max-width: 65%;
    min-width: 65%;
    border-radius: 0px 0px 30px 30px;
  }
  .language-selection-wrapper {
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1), 0px 15px 30px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 2em;
    width: 65%;
    margin-bottom: 2em;
    text-align: center;
    /* Flexbox a középre igazításhoz */
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    margin-top: -3em;
  }
}
@media (min-width: 1641px) {
  .language-selection-image {
    width: 33%;
    max-width: 33%;
    min-width: 33%;
  }
  .language-selection-wrapper {
    box-shadow: 0px 10px 15px rgba(0, 0, 0, 0.1), 0px 15px 30px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding: 2em;
    width: 33%;
    margin-bottom: 2em;
    text-align: center;
    /* Flexbox a középre igazításhoz */
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    margin-top: -3em;
  }
}
.version {
  font-size: 8px;
  padding-right: 10px;
  font-style: italic;
}

.version-container {
  position: fixed;
  bottom: 35px;
  right: 5px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
